import { z } from 'zod';
import { ObjectIdSchema } from '../../../../shared/object-id.schema';
import { BaseErrorSchema } from '../../../../shared/error.schema';
/**
 * Dismiss Clone Job Request Schema
 * DELETE /api/v2/tenant-clone-jobs/:jobId
 *
 * Path param only. Clears the job document and NOTHING else — no rollback, no
 * database drop, no tenant deletion.
 *
 * The case this exists for: a clone whose tenant was KEPT (`importFailed`,
 * `completed`). Discard refuses those by design, so acknowledging the notice is
 * the only action left. An `importFailed` demo tenant has NO working sign-in
 * until `scripts/demo-provision-retry.ts` converges it — the clone strips
 * legacy credential material from every copied user, so neither an IdP account
 * nor a password exists — which is why dismissing is an acknowledgement of work
 * already done by hand, never a substitute for it.
 */ export const DismissCloneJobRequestSchema = z.object({
    jobId: ObjectIdSchema
});
/**
 * Dismiss Clone Job Response Schema
 *
 * A bare acknowledgement: nothing was undone, so there is no cleanup record to
 * report. The tenant, its database and its memberships are all untouched.
 */ export const DismissCloneJobResponseSchema = z.object({
    success: z.boolean()
});
/**
 * Dismiss Clone Job Error Schema
 */ export const DismissCloneJobErrorSchema = BaseErrorSchema;

//# sourceMappingURL=dismiss-clone-job.schema.js.map